<ion-grid class="ion-margin-bottom">
  <ion-row>
    <ion-col size="11">
      <app-sort
        class="app-sort-data"
        [tableHeaders]="listHeaders"
        (sortEvent)="sortData($event)"
        [sorting]="startSort"
      ></app-sort>
    </ion-col>
    <ion-col size="1" class="refresh-button-col">
      <ion-button id="refreshButtonFeedback" fill="clear" color="primary" (click)="refreshData()" class="refresh-button">
        <ion-icon slot="icon-only" name="refresh-outline" color="primary" size="large"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-list *ngIf="!checkIfData() && !isDataFetched">
    <ion-item *ngFor="let item of [1]" lines="none">
      <ion-label>
        <p *ngFor="let line of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="ion-padding-top">
          <ion-skeleton-text class="nimus_red" [animated]="true"></ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
  </ion-list>

  <ion-row
    *ngIf="!checkIfData() && isDataFetched"
    class="ion-justify-content-center animate__animated animate__fadeIn animate__fast">
    <ion-col size="auto">
      <ion-item lines="none">{{ 'NO_DATA' | translate }}</ion-item>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="checkIfData()">
    <ion-col size="12">
      <ng-container>
        <ion-list>
          <app-feedback-item *ngFor="let item of listData" [item]="item" ></app-feedback-item>
        </ion-list>
      </ng-container>
    </ion-col>
  </ion-row>
</ion-grid>
